import axios from 'axios'
import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

// O handler do backend devolve [{ msgUsuario, msgDesenvolvedor }] em erros de regra
// de negocio (ex.: "Ja existe organizacao com o identificador: ...", sub-dominio
// invalido). catchError() ignora esse corpo e cai no generico; aqui surfaceamos a
// msgUsuario quando existir, caindo no catchError generico caso contrario.
const erroOrganizacao = (error: unknown): { message: string } => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data
    const msg = Array.isArray(data) ? data[0]?.msgUsuario : undefined
    if (msg) {
      return { message: msg }
    }
  }
  return catchError(error)
}

export const getOrganization = async (): Promise<
  GetOrganizationsType[] | { message: string }
> => {
  try {
    const result = await apiService.get('central/organizacao')
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
export const getOrganizationListAll = async (
  query: string,
  page: number
): Promise<GetOrganizationsListAllType | { message: string }> => {
  try {
    const result = await apiService.get('central/organizacao/all', {
      params: {
        query,
        page: page - 1,
        size: 7,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const fetchNovaOrganizacao = async (organizacaoRequestDTO: {}): Promise<
  { info: string } | { message: string }
> => {
  try {
    const result = await apiService.post('central/organizacao', {
      ...organizacaoRequestDTO,
    })
    if (result.status === 200) {
      return { info: 'Nova organização criada!' }
    }
    if (result.status === 201) {
      return { info: 'Organização criada com sucesso!' }
    }
  } catch (error) {
    return erroOrganizacao(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const fetchAtivaDesativaOrganizacao = async (
  id: number,
  acao: string
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.put(`central/organizacao/${acao}/${id}`)
    if (result.status === 200) {
      return acao === 'ativar'
        ? { info: 'Organização ativada!' }
        : { info: 'Organização desativada!' }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const fetchEditaOrganizacao = async (
  id: number,
  organizacaoEditRequestDTO: {}
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.put(`central/organizacao/${id}`, {
      ...organizacaoEditRequestDTO,
    })
    if (result.status === 200) {
      return { info: 'Organização editada com sucesso!' }
    }
  } catch (error) {
    return erroOrganizacao(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
